var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
var FormatDate = function (_a) {
    var startDateString = _a.startDate, endDateString = _a.endDate, className = _a.className, style = _a.style, location = _a.location, longFormat = _a.longFormat;
    var startDate = new Date(startDateString);
    var endDate = new Date(endDateString);
    function getTimeTag(_a) {
        var _b = _a === void 0 ? {} : _a, singleDate = _b.singleDate;
        var range = getDateRange({ startDate: startDate, endDate: endDate, longFormat: longFormat });
        var rangeSplit = range.split('-');
        var start = rangeSplit[0];
        var end = rangeSplit[1];
        if (singleDate) {
            return (_jsxs(_Fragment, { children: [_jsx("time", __assign({ className: className, dateTime: startDateString }, { children: range })), location && (_jsxs("span", __assign({ className: className, style: style }, { children: [' ', "\u00B7 ", location] })))] }));
        }
        return (_jsxs(_Fragment, { children: [_jsx("time", __assign({ className: className, style: style, dateTime: startDateString }, { children: start })), _jsx("span", __assign({ className: className, style: style }, { children: "-" })), _jsx("time", __assign({ className: className, style: style, dateTime: endDateString }, { children: end })), location && (_jsxs("span", __assign({ className: className, style: style }, { children: [' ', "\u00B7 ", location] })))] }));
    }
    if (startDate.getFullYear() === endDate.getFullYear()) {
        if (startDate.getMonth() === endDate.getMonth()) {
            if (startDate.getDay() === endDate.getDay()) {
                return getTimeTag({ singleDate: true });
            }
            else {
                return getTimeTag();
            }
        }
        else {
            return getTimeTag();
        }
    }
    else {
        return getTimeTag();
    }
};
var getDateRange = function (params) {
    var startDateMonth;
    var endDateMonth;
    var startDate = params.startDate, endDate = params.endDate, longFormat = params.longFormat;
    var startDay = startDate.getUTCDate();
    var endDay = endDate.getUTCDate();
    if (longFormat) {
        startDateMonth = startDate.toLocaleString('default', {
            month: 'long',
            timeZone: 'utc'
        });
        endDateMonth = endDate.toLocaleString('default', {
            month: 'long',
            timeZone: 'utc'
        });
    }
    else {
        startDateMonth = startDate.toLocaleString('default', {
            month: 'short',
            timeZone: 'utc'
        });
        endDateMonth = endDate.toLocaleString('default', {
            month: 'short',
            timeZone: 'utc'
        });
    }
    var startDateYear = startDate.getUTCFullYear();
    var endDateYear = endDate.getUTCFullYear();
    return startDateYear === endDateYear
        ? startDateMonth === endDateMonth
            ? startDay === endDay
                ? "".concat(endDateMonth, " ").concat(startDay, ", ").concat(endDateYear)
                : "".concat(endDateMonth, " ").concat(startDay, "-").concat(endDay, ", ").concat(endDateYear)
            : "".concat(startDateMonth, " ").concat(startDay, "-").concat(endDateMonth, " ").concat(endDay, ", ").concat(endDateYear)
        : "".concat(startDateMonth, " ").concat(startDay, ", ").concat(startDateYear, "-").concat(endDateMonth, " ").concat(endDay, ", ").concat(endDateYear);
};
function formatDate(date, longFormat) {
    var newDate;
    if (date instanceof Date) {
        newDate = date;
    }
    else {
        newDate = new Date(date);
    }
    if (longFormat) {
        return format(newDate, 'MMMM d, yyyy');
    }
    return format(newDate, 'MMM d, yyyy');
}
function formatDateUTC(date, longFormat) {
    var dateObj = typeof date === 'string' ? new Date(date) : date;
    var utcDate = utcToZonedTime(dateObj, 'UTC');
    var formatString = longFormat ? 'MMMM d, yyyy' : 'MMM d, yyyy';
    return format(utcDate, formatString);
}
export default FormatDate;
export { formatDate, formatDateUTC, getDateRange };
//# sourceMappingURL=index.js.map